module.exports = __webpack_public_path__ + "static/img/tc.5e51f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/tc.png
// module id = /Mv+
// module chunks = 1